import { render, staticRenderFns } from "./recommendAd.vue?vue&type=template&id=4a334e75&scoped=true"
import script from "./recommendAd.vue?vue&type=script&lang=js"
export * from "./recommendAd.vue?vue&type=script&lang=js"
import style0 from "./recommendAd.vue?vue&type=style&index=0&id=4a334e75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a334e75",
  null
  
)

export default component.exports